import React from 'react';

import { useRouteMatchStrict } from 'hooks/useRouteMatchStrict';
import { AdminNavigation } from 'containers/AdminNavigation';
import { AdminPageLayout } from 'design/adminPageLayout';
import { BillsPageContent } from 'containers/BillsPage/BillsPageContent';

type MatchParams = {
  page: string;
};

export const BillsPage = () => {
  const {
    params: { page: currentPageText },
  } = useRouteMatchStrict<MatchParams>();

  // Номер страницы из роутера приходит в виде текста.
  // Для дальнейшей работы значение приводится к числу.
  const currentPage = Number(currentPageText);

  return (
    <AdminPageLayout
      sidebarNode={<AdminNavigation />}
      contentNode={<BillsPageContent currentPage={currentPage} />}
    />
  );
};
